module.exports = __webpack_public_path__ + "img/02.6cdd9fa9.jpg";